module.exports = __webpack_public_path__ + "img/phone_2.d0897722.webp";